module.exports = __webpack_public_path__ + "img/img_Intelligentdiagnosis_c.e1020b8a.png";